import * as React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { GuestType } from 'types/Hotel';
import { reviewsLabels } from 'utils/reviewsMessages';
import { Icon, iconsList } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
type GuestTypeKey = keyof GuestType;
type PropsType = {
  /** The guest type */
  guestTypeKey: GuestTypeKey;
  /** The value for the percentage in the label */
  value: number;
};
const iconMap: Record<GuestTypeKey, keyof typeof iconsList> = {
  business: 'Briefcase',
  couples: 'Heart',
  families: 'FaceLove',
  groups: 'People',
  solo: 'Person'
};
const GuestTypeBadgeWrapper = /*#__PURE__*/styled('div')({
  name: "GuestTypeBadgeWrapper",
  class: "g15qlbw0",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "ii5k60c",
  propsAsIs: false
});
export const GuestTypeBadge = ({
  guestTypeKey,
  value
}: PropsType) => {
  const {
    formatMessage
  } = useIntl();
  const iconName = iconMap[guestTypeKey];
  if (!reviewsLabels[guestTypeKey]) return null;
  return <GuestTypeBadgeWrapper>
      <IconWrapper>
        <Icon name={iconName} size="lg" />
      </IconWrapper>

      <Text variant="bodyS">{formatMessage(reviewsLabels[guestTypeKey])}</Text>

      <Text variant="labelS" colorPath="content.neutral.c600">
        {Math.floor(value)}%
      </Text>
    </GuestTypeBadgeWrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");